import * as React from "react";
import ProductPage from "@/ReactComponents/ProductPage/product-page";

const ProductPageView = props => <ProductPage {...props} />;

export default ProductPageView;
